import { PlusOutlined, TableOutlined } from "@ant-design/icons";
import { Modal, Form, Input, Select, Col, Row, Divider, Tabs, Button, DatePicker, message, Tooltip, Radio, Space, InputNumber } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { useEffect, useState } from "react";
import dayjs from 'dayjs';
import { SpecialitesService } from "../Services/SpecialitesService";
import { DemandeAgrService } from "../Services/DemandeAgrService";
import DemandeAgr from "./DemandeAgr";
import GeoLocationField from "./Modal/GeoLocationField";
import { PaysService } from "../Services/PaysService";
import Region from "./Region";

const { Option } = Select;

const generateDashes = (maxLength) => '_ '.repeat(maxLength).trim();

const CreaFournDiv = ({ record, onSuccess }) => {
  const [showDemandeAgr, setShowDemandeAgr] = useState(false);
  const [telephoneFixe, setTelephoneFixe] = useState('');
  const [telephoneMobile, setTelephoneMobile] = useState('');
  const [specialitesData, setSpecialitesData] = useState([]);
  const [paysData, setPaysData] = useState([]);
  const [selectedAgree, setSelectedAgree] = useState(record ? record.agree : null);
  const [form] = Form.useForm();

  const userId = localStorage.getItem('login');

  const demandeAgrService = new DemandeAgrService();
  const specialistesService = new SpecialitesService();
  const paysService = new PaysService();
  const handleShowDemandeAgr = () => {
    form.resetFields();
    setShowDemandeAgr(true);
  };

  const handleTelephoneChange = (e, setTelephone) => {
    const value = e.target.value.replace(/\D/g, '');
    const formattedValue = value.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1  $2  $3  $4');
    setTelephone(formattedValue);
  };

  const fetchSpecialite = async () => {
    try {
      const specialites = await specialistesService.getAllSpecialites();
      setSpecialitesData(specialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités :", error);
      message.error("Erreur lors de la récupération des spécialités");
    }
  };

  const fetchPays = async () => {
    try {
      const pays = await paysService.getAllPays();
      setPaysData(pays);
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités :", error);
      message.error("Erreur lors de la récupération des spécialités");
    }
  };
  useEffect(() => {
    fetchSpecialite();
    fetchPays()
  }, []);

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        ...record,
        date_dem_agreement: dayjs(record.date_dem_agreement),
      });
      setTelephoneFixe(record.telFix);
      setTelephoneMobile(record.contact_portable);
    }
  }, [record, form]);
  const handleSubmit = async (values) => {
    try {
      console.log("Valeurs du formulaire :", values);
      console.log("Téléphone Fixe :", telephoneFixe);
      console.log("Téléphone Mobile :", telephoneMobile);

      const payload = {
        ...values,
        adresse: values.adresse,
        agree: values.agree,
        banque: values.banque || null,
        bp: values.bp || null,
        cleRib: values.cleRib || null,
        codeAgence: values.codeAgence || null,
        codeBque: values.codeBque || null,
        codespe: values.codespe,
        compte: values.compte || null,
        contact_fonction: values.contact_fonction,
        contact_nom: values.contact_nom,
        contact_portable: telephoneMobile,
        contact_prenom: values.contact_prenom,
        coordgeo: values.coordgeo || null,
        cpteBque: values.cpteBque || null,
        dateDebConv: values.dateDebConv || "",
        dateDebSpe: values.dateDebSpe || "",
        dateFinConv: values.dateFinConv || "",
        date_fin_carte_pro: values.date_fin_carte_pro || "",
        delaicredit: values.delaicredit || null,
        email: values.email,
        fax: values.fax || null,
        numFourn: record ? record.numFourn : undefined,
        num_arret_aut: values.num_arret_aut || "",
        num_carte_pro: values.num_carte_pro || "",
        num_ordre: values.num_ordre || "",
        pays: values.pays || "SEN",
        portable: values.portable || null,
        raisoc: values.raisoc,
        region: values.region || "",
        siteweb: values.siteweb || "",
        spec_admin: values.spec_admin || "",
        statut: record ? record.statut : undefined,
        telFix: telephoneFixe,
        user_id: userId
      };

      console.log("Payload envoyé :", payload);

      if (record) {
        await demandeAgrService.modifDemandeAgr(payload);
        message.success("Demande d'agrément mise à jour avec succès");
      } else {
        await demandeAgrService.ajoutDemandeAgr(payload);
        message.success("Demande d'agrément enregistrée avec succès");
      }
      form.resetFields();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Erreur lors de la soumission du formulaire: ", error);
      message.error("Erreur lors de la soumission du formulaire");
    }
  };
  const handleAgreeChange = (e) => {
    setSelectedAgree(e.target.value);
  };

  const getRadioButtonStyle = (value) => {
    const commonStyles = {
      borderColor: selectedAgree ? getRadioGroupStyle().borderColor : 'transparent',
      color: selectedAgree ? getRadioGroupStyle().borderColor : 'black',
    };
    if (selectedAgree === value) {
      let backgroundColor, color;
      switch (value) {
        case 'C':
          backgroundColor = '#e0ce07';
          color = 'black';
          break;
        case 'A':
          backgroundColor = '#67f02e';
          color = 'black';
          break;
        case 'R':
          backgroundColor = '#fc0b03';
          color = 'black';
          break;
        default:
          backgroundColor = 'transparent';
          color = 'black';
          break;
      }
      return { ...commonStyles, backgroundColor, color };
    } else {
      return commonStyles;
    }
  };

  const getRadioGroupStyle = () => {
    switch (selectedAgree) {
      case 'C':
        return { borderColor: '#e0ce07' };
      case 'A':
        return { borderColor: '#67f02e' };
      case 'R':
        return { borderColor: '#fc0b03' };
      default:
        return {};
    }
  };



  return (
    <div>
      {!showDemandeAgr && (
        <div style={{ borderRadius: '10px', boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.1)', padding: '20px', width: '100%', margin: '0 auto', backgroundColor: '#fff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ color: '#03284a', margin: '0' }}>
              {record ? ` Demande d'Agréments Fournisseurs N° ${record.numFourn}` : "Nouvelle Demande d'Agréments Fournisseurs"}
            </h2>
            <Button type="primary" style={{ alignSelf: 'flex-end' }} icon={<TableOutlined />} onClick={handleShowDemandeAgr}>
              Liste des demandes
            </Button>
          </div>
          <Form form={form} layout="vertical" style={{ width: '100%', margin: "0 auto" }} onFinish={handleSubmit}>
            <Divider orientation="left"></Divider>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="codespe" label="Spécialité" rules={[{ required: true, message: 'Veuillez sélectionner une spécialité' }]}>
                  <Select disabled={!!record} showSearch>
                    {specialitesData && specialitesData.map((specialite) => (
                      <Option key={specialite.codespe} value={specialite.codespe}>
                        {`${specialite.codespe} - ${specialite.intitule}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {!record && (
                <Col span={8}>
                  <Form.Item name="date_dem_agreement" label="Date demande agrément" initialValue={dayjs()} rules={[{ required: true, message: 'Veuillez sélectionner une date' }]}>
                    <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} disabledDate={(current) => current && current > dayjs().endOf('day')} />
                  </Form.Item>
                </Col>
              )}
              {record && (
                <Col span={8}>
                  <Form.Item name="numFourn" label="N°" rules={[{ required: true, message: "champs Requis" }]}>
                    <Input disabled={!!record} />
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item name="raisoc" label="Raison Sociale" rules={[{ required: true, message: "Veuillez saisir la Raison Sociale" }]}>
                  <Input />
                </Form.Item>
              </Col>

            </Row>


            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="email" label="Email" rules={[{ type: 'email', message: "Veuillez saisir un email valide" }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="adresse" label="Adresse" rules={[{ required: true, message: "Veuillez saisir l'adresse" }]}>
                  <Input />
                </Form.Item>
              </Col>
              {record && (
                <Col span={6}>
                  <Form.Item name="agree" label="Agrément" rules={[{ required: true, message: "Veuillez sélectionner l'agrément" }]}>
                    <Radio.Group onChange={handleAgreeChange} value={selectedAgree} style={{ borderColor: getRadioGroupStyle().borderColor, borderWidth: 1, borderStyle: 'solid', borderRadius: 0 }}>
                      <Radio.Button style={getRadioButtonStyle('C')} value="C">En cour</Radio.Button>
                      <Radio.Button style={getRadioButtonStyle('A')} value="A">Agréé</Radio.Button>
                      <Radio.Button style={getRadioButtonStyle('R')} value="R">Rejeté</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              )}
              <Col span={8}>
                <Form.Item label="Delai de Règlement (jr)" initialValue={60} name="delaicredit">
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
            <Divider orientation="left"></Divider>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="typeStructure" label="Type de structure" >
                  <Select>
                    <Option value="public">Public</Option>
                    <Option value="prive">Privé</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="but" label="But" >
                  <Select>
                    <Option value="lucratif">Lucratif</Option>
                    <Option value="nonLucratif">Non Lucratif</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="niveau" label="Niveau" >
                  <Select>
                    <Option value="n1">N1</Option>
                    <Option value="n2">N2</Option>
                    <Option value="n3">N3</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="code_ipm" label="Code IPM" >
                  <Input />
                </Form.Item>
              </Col>

            </Row>
            <Divider orientation="left">Contact</Divider>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="contact_nom" label="Nom" rules={[{ required: true, message: 'Veuillez saisir le nom du contact' }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="contact_prenom" label="Prénom" rules={[{ required: true, message: 'Veuillez saisir le prénom du contact' }]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="contact_fonction" label="Fonction" rules={[{ required: true, message: 'Veuillez saisir la fonction du contact' }]}>
                  <Input />
                </Form.Item>
              </Col>

            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="telFix" label="Téléphone Fixe">
                  <Input addonBefore="+221" placeholder={generateDashes(9)} maxLength={9} value={telephoneFixe} onChange={(e) => handleTelephoneChange(e, setTelephoneFixe)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="contact_portable" label="Téléphone Mobile">
                  <Input addonBefore="+221" placeholder={generateDashes(9)} maxLength={9} value={telephoneMobile} onChange={(e) => handleTelephoneChange(e, setTelephoneMobile)} />
                </Form.Item>
              </Col>
            </Row>


            <Divider orientation="left">Références Professionnelles</Divider>
            {!record && (
              <Tabs defaultActiveKey="1">
                <TabPane tab="Carte médecin/pharmacien" key="1">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item name="num_carte_medecin" label="Numéro">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="date_delivrance_carte_medecin" label="Date de délivrance">
                        <DatePicker style={{ width: "100%" }} disabledDate={(current) => current && current > dayjs().endOf('day')} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="autorite_carte_medecin" label="Autorité">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Immatriculation au R.C" key="2">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item name="num_rc" label="Numéro R.C">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="date_rc" label="Date">
                        <DatePicker style={{ width: "100%" }} disabledDate={(current) => current && current > dayjs().endOf('day')} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="ninea" label="NINEA">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Autorisation ministère de la santé" key="3">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item name="num_autorisation" label="Numéro">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="date_autorisation" label="Date de délivrance">
                        <DatePicker style={{ width: "100%" }} disabledDate={(current) => current && current > dayjs().endOf('day')} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Identification bancaire" key="4">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item name="banque" label="Nom Banque">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="codeBque" label="Code Banque">
                        <Input addonBefore="SN" placeholder={generateDashes(3)} maxLength={3} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="codeAgence" label="Code Guichet">
                        <Input maxLength={5} placeholder={generateDashes(5)} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="cpteBque" label="Compte Bancaire">
                        <Input maxLength={12} placeholder={generateDashes(12)} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="cleRib" label="Clé RIB">
                        <Input maxLength={2} placeholder={generateDashes(2)} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            )}
            {record && (
              <Tabs defaultActiveKey="1">
                <TabPane tab="Identification bancaire" key="1">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item name="banque" label="Nom Banque">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="codeBque" label="Code Banque">
                        <Input addonBefore="SN" placeholder={generateDashes(3)} maxLength={3} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="codeAgence" label="Code Guichet">
                        <Input maxLength={5} placeholder={generateDashes(5)} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="cpteBque" label="Compte Bancaire">
                        <Input maxLength={12} placeholder={generateDashes(12)} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="cleRib" label="Clé RIB">
                        <Input maxLength={2} placeholder={generateDashes(2)} />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Localisation" key="2">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item label="Région" name="region">
                        <Region />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Pays" name="pays">
                        <Select >
                          {paysData && paysData.map((paysd) => (
                            <Option key={paysd.alpha3} value={paysd.alpha3}>
                              {`${paysd.alpha3} - ${paysd.nom_fr_fr}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Site web" name="siteweb">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="coordgeo"
                    label="Coordonnées géographiques"

                  >
                    <GeoLocationField />
                  </Form.Item>
                </TabPane>
                <TabPane tab="Documents administratifs" key="3">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item name="num_ordre" label="N° Inscription au Tableau de l'Ordre">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="N° Carte Professionnelle" name="num_carte_pro">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="N° Arrêté Autorisation" name="num_arret_aut">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="date_fin_carte_pro" label="Date Fin Validité Carte Professionnelle">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Convention" key="4">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item label="Date Début Convention" name="dateDebConv">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="dateFinConv" label="Date Fin Convention">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            )}
            <Form.Item style={{ textAlign: "right" }}>
              <Space>
                <Button onClick={handleShowDemandeAgr} className="buttonClose">Annuler</Button>
                <Button type="primary" htmlType="submit" className="Buttonvalid">Enregistrer</Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      )}
      {showDemandeAgr && <DemandeAgr />}
    </div>
  );
};

export default CreaFournDiv;
